import {
  queryDataType,
  getNestedVariables,
  queryVariablesMap,
  queryDataNameAndArgumentMap,
  queryFieldsMap
} from './utils';

export default class Generator {
  constructor(options) {
    this.variables = options.variables;
    this.fields = options.fields;
    this.operation = options.operation;
    this.config = {
      operationName: ''
    };
  }
  mutationBuilder = () => {
    return this.operationWrapperTemplate(
      'mutation',
      this.variables,
      this.operationTemplate(this.operation)
    );
  };

  queryBuilder = () => {
    return this.operationWrapperTemplateForQuery(
      this.operationTemplateForQuery(this.variables)
    );
  };

  operationTemplateForQuery = (variables) => {
    return `${this.operation} ${
      variables ? queryDataNameAndArgumentMap(variables) : ''
    } ${
      this.fields && this.fields.length > 0
        ? '{ ' + queryFieldsMap(this.fields) + ' }'
        : ''
    }`;
  };

  operationWrapperTemplateForQuery = (content) => {
    let query = `query ${this.queryDataArgumentAndTypeMapForQuery()} { ${content} }`;
    query = query.replace(
      'query',
      `query${
        this.config.operationName !== '' ? ' ' + this.config.operationName : ''
      }`
    );
    return {
      query,
      variables: queryVariablesMap(this.variables, this.fields)
    };
  };

  queryDataArgumentAndTypeMapForQuery = () => {
    let variablesUsed = this.variables;

    if (this.fields && typeof this.fields === 'object') {
      variablesUsed = {
        ...getNestedVariables(this.fields),
        ...variablesUsed
      };
    }
    return variablesUsed && Object.keys(variablesUsed).length > 0
      ? `(${Object.keys(variablesUsed).reduce(
          (dataString, key, i) =>
            `${dataString}${i !== 0 ? ', ' : ''}$${key}: ${queryDataType(
              variablesUsed[key]
            )}`,
          ''
        )})`
      : '';
  };

  operationWrapperTemplate = (type, variables, content) => {
    return {
      query: `${type} ${this.queryDataArgumentAndTypeMap(variables)} {
                ${content}
            }`,
      variables: queryVariablesMap(variables)
    };
  };

  queryDataNameAndArgumentMap() {
    let inputVariables = {};
    let normalVariables = {};
    Object.keys(this.variables).forEach((el) => {
      if (this.variables[el].inputVariable) {
        inputVariables[el] = this.variables[el];
      } else {
        normalVariables[el] = this.variables[el];
      }
    });
    return this.variables && Object.keys(this.variables).length
      ? `(${Object.keys(normalVariables).reduce(
          (dataString, key, i) =>
            `${dataString}${i !== 0 ? ', ' : ''}${key}: $${key}`,
          ''
        )}${
          Object.keys(inputVariables).length > 0
            ? `,
        input: {
            ${Object.keys(inputVariables).reduce(
              (dataString, key, i) =>
                `${dataString}${i !== 0 ? ', ' : ''}${key}: $${key}`,
              ''
            )}
            }`
            : ''
        })`
      : '';
  }

  operationTemplate(operation) {
    return `${operation} ${this.queryDataNameAndArgumentMap()} ${
      this.fields && this.fields.length > 0
        ? `{
        ${this.queryFieldsMap(this.fields)}
      }`
        : ''
    }`;
  }

  queryFieldsMap(fields) {
    return fields
      ? fields
          .map((field) =>
            typeof field === 'object'
              ? `${Object.keys(field)[0]} { ${this.queryFieldsMap(
                  Object.values(field)[0]
                )} }`
              : `${field}`
          )
          .join(', ')
      : '';
  }

  queryDataArgumentAndTypeMap(variables) {
    if (!variables) {
      return '';
    }
    return Object.keys(variables).length
      ? `(${Object.keys(variables).reduce(
          (dataString, key, i) =>
            `${dataString}${i !== 0 ? ', ' : ''}$${key}: ${queryDataType(
              variables[key]
            )}`,
          ''
        )})`
      : '';
  }
}
